import { connect } from 'react-redux';
import { saveGlobalConfig, updateDates } from '../../FilterActions';
import { DateRangePicker } from './DateRangePicker';

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: updateHash => dispatch(saveGlobalConfig(true, updateHash)),
    updateValue: (val, update) => dispatch(updateDates(val, update))
  };
};

const mapStateToProps = state => {
  return {
    value: state.filters.dates,
    dateFormat: state.filters.dateFormat,
    dashboard: state.dashboards.selected
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(DateRangePicker);
export { connected as DatePicker };
